// src/pages/Billing.js
"use client";
import React, { useEffect, useState } from "react";
import { Container, Stack, Typography, Button, AppBar, Toolbar, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useAuth } from "../auth/AuthContext";
import { getMe, openPortal } from "../api/billing";
import PlanBadge from "../components/PlanBadge";
import ThemeToggleButton from "../components/ThemeToggleButton";
import { Link as RouterLink } from "react-router-dom";

const LOGO_LIGHT = "/brand/SemiQolon-black.png";
const LOGO_DARK  = "/brand/SemiQolon.png";

export default function Billing() {
  const { user } = useAuth();
  const theme = useTheme();
  const logoSrc = theme.palette.mode === "dark" ? LOGO_DARK : LOGO_LIGHT;

  const [me, setMe] = useState(null);

  useEffect(() => {
    if (!user?.sub) return;
    (async () => setMe(await getMe(user.sub)))();
  }, [user?.sub]);

  const portal = async () => {
    const url = await openPortal(user.sub);
    window.location.href = url;
  };

  return (
    <>
      <AppBar position="sticky" color="inherit" elevation={0} sx={{ borderBottom: "1px solid", borderColor: "divider" }}>
        <Toolbar sx={{ gap: 2 }}>
          <Box component={RouterLink} to="/" sx={{ display: "flex", alignItems: "center", gap: 1.25, textDecoration: "none" }}>
            <Box component="img" src={logoSrc} alt="SemiQolon Studio" sx={{ height: 32 }} />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: 800, flexGrow: 1 }}>Billing</Typography>
          {me?.plan && <PlanBadge plan={me.plan} />}
          <ThemeToggleButton />
          <Button component={RouterLink} to="/studio" variant="contained">Back to Studio</Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm" sx={{ py: 6 }}>
        <Stack spacing={2} alignItems="center" textAlign="center">
          <Typography variant="h4" sx={{ fontWeight: 900 }}>Thanks!</Typography>
          <Typography variant="body1" color="text.secondary">
            Your subscription was updated. Current plan:
          </Typography>
          <PlanBadge plan={me?.plan || "FREE"} />
          <Stack direction="row" spacing={1.5} sx={{ mt: 2 }}>
            <Button variant="contained" onClick={portal}>Open billing portal</Button>
            <Button component={RouterLink} to="/studio" variant="outlined">Go to Studio</Button>
          </Stack>
        </Stack>
      </Container>
    </>
  );
}
